import { AnalyticsTable } from 'features/analytics/components/AnalyticsTable/AnalyticsTable'
import AnalyticsTabsView from 'features/analytics/components/AnalyticsTabView'
import { useAnalytics } from 'features/analytics/hooks/useAnalytics'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { SettingsPage } from 'shared/components/settings/SettingsPage'
import { useGetNumbersAnalyticsQuery } from 'shared/store'

interface Props {}

const Numbers: React.FC<Props> = () => {
    const { dateScroller, group } = useAnalytics()
    const { t } = useTranslation()
    const {
        data: numbersAnalyticsData,
        // isUninitialized,
        isFetching,
        isLoading
        // isError
    } = useGetNumbersAnalyticsQuery(
        {
            from: dateScroller.start?.getTime().toString(),
            to: dateScroller.end?.getTime().toString(),
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            group
        },
        { skip: !dateScroller.start || !dateScroller.end }
    )

    const isNoResults = !numbersAnalyticsData?.data.length

    return (
        <div>
            <SettingsPage
                title={t('analytics.numbers')}
                subtitle={t('analytics.numbersSubtitle')}
                isLoading={isLoading || isFetching}
                contentProps={{ padding: 0, maxW: 'unset' }}
            >
                <AnalyticsTabsView
                    noResults={isNoResults}
                    isLoading={isLoading || isFetching}
                    header={null}
                >
                    <AnalyticsTable numbersData={numbersAnalyticsData?.data} />
                </AnalyticsTabsView>
            </SettingsPage>
        </div>
    )
}

export default Numbers
